import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "gfu-hd gfu-hd--h3 _tc--inherit",
  "data-qa": "mini-wizard-header:Backer"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  "format-key": "0",
  "data-qa": "mini-wizard-header:BackerNumber"
}
const _hoisted_4 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.backerNumber)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_component_localize, {
            resource: _ctx.Resources.ProjectHome.MiniWizardBackerNumberText
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString($options.backerNumberFormatted), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"])
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($options.header), 1 /* TEXT */))
  ]))
}